import { Component, OnInit } from "@angular/core";
import { StaticPageGetByPageKeyOutputDTO } from 'src/app/models/contents.models/staticPage.models/staticPageGetByPageKeyOutputDTO.model';
import { SiteSEOHelperService } from 'src/app/services/siteseoHelper.service';
import { StaticPagesSiteService } from 'src/app/services/staticPagesSite.service';
import { DResult } from 'src/app/models/common.models/dresult.model';
import { FAQsSiteService } from 'src/app/services/fAQsSite.service';
import { FAQGetListOutputDTO } from 'src/app/models/contents.models/FAQ.models/FAQGetListOutputDTO.model';

@Component({
  selector: "faqs",
  templateUrl: "faqs.component.html"
})
export class FAQsComponent implements OnInit {
  ngOnInit(): void {
    this.GetCommonPage();
    this.GetFAQs();
  }

  pageKey: string = "FAQsIndex";
  commonPage: StaticPageGetByPageKeyOutputDTO = new StaticPageGetByPageKeyOutputDTO();
  faqItems: FAQGetListOutputDTO[] = [];

  constructor(
    private siteSEOHelperService: SiteSEOHelperService,
    private staticPagesSiteService: StaticPagesSiteService,
    private fAQsSiteService: FAQsSiteService
  ) {}

  GetCommonPage() {
    this.staticPagesSiteService
      .GetByPageKey(this.pageKey)
      .subscribe((data: DResult<StaticPageGetByPageKeyOutputDTO>) => {
        if (data.isSuccess) {
          this.commonPage = data.result;

          this.siteSEOHelperService.SetPageMetaData(
            this.commonPage.metaTitle,
            this.commonPage.metaDescription,
            this.commonPage.metaKeywords
          );
        }
      });
  }

  GetFAQs() {
    this.fAQsSiteService
      .GetList()
      .subscribe((data: DResult<FAQGetListOutputDTO[]>) => {
        if (data.isSuccess) {
          this.faqItems = data.result;
        }
      });
  }

}
